import axios from 'axios';

let prefix = "/coupon"

const CouponApi = {
	getCouponList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getCouponById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createCoupon(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateCoupon(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveCoupon(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	getCouponListRef(payload){
		return axios.get( prefix + "/list-ref", {params: payload})
	},
}

export default CouponApi;